import React from "react";
import { useSection } from "./useSection";
import { Field, SaveBar } from "./ui";
import { ImageField } from "./ImageField";

export default function HomeEditor({ logout }) {
  const hero = useSection("hero", logout);
  const about = useSection("about", logout);

  const setHero = (k, v) => hero.setDraft({ ...hero.draft, [k]: v });
  const setAbout = (k, v) => about.setDraft({ ...about.draft, [k]: v });

  return (
    <div className="space-y-16">
      {hero.draft && (
        <section>
          <SaveBar title="Sezione principale (Hero)" description="Il grande titolo e l'immagine in cima alla home." saving={hero.saving} onSave={hero.save} />
          <div className="grid md:grid-cols-2 gap-6">
            <Field label="Sopratitolo" value={hero.draft.eyebrow} onChange={(v) => setHero("eyebrow", v)} />
            <Field label="Titolo — riga 1" value={hero.draft.titleTop} onChange={(v) => setHero("titleTop", v)} />
            <Field label="Titolo — parola in oro" value={hero.draft.titleEmphasis} onChange={(v) => setHero("titleEmphasis", v)} />
            <Field label="Titolo — fine" value={hero.draft.titleEnd} onChange={(v) => setHero("titleEnd", v)} />
            <div className="md:col-span-2">
              <Field label="Sottotitolo" value={hero.draft.subtitle} onChange={(v) => setHero("subtitle", v)} textarea />
            </div>
            <Field label="Pulsante principale" value={hero.draft.ctaPrimary} onChange={(v) => setHero("ctaPrimary", v)} />
            <Field label="Pulsante secondario" value={hero.draft.ctaSecondary} onChange={(v) => setHero("ctaSecondary", v)} />
          </div>
          <div className="mt-8 max-w-xl">
            <ImageField label="Immagine hero" value={hero.draft.image} onChange={(v) => setHero("image", v)} logout={logout} ratio="aspect-video" />
          </div>
        </section>
      )}

      {about.draft && (
        <section>
          <SaveBar title="Chi siamo" description="Testi e immagine della sezione di presentazione." saving={about.saving} onSave={about.save} />
          <div className="grid md:grid-cols-2 gap-6">
            <Field label="Sopratitolo" value={about.draft.eyebrow} onChange={(v) => setAbout("eyebrow", v)} />
            <Field label="Titolo" value={about.draft.title} onChange={(v) => setAbout("title", v)} />
          </div>
          <div className="mt-6 space-y-6">
            <Field label="Paragrafo 1" value={about.draft.paragraph1} onChange={(v) => setAbout("paragraph1", v)} textarea rows={4} />
            <Field label="Paragrafo 2" value={about.draft.paragraph2} onChange={(v) => setAbout("paragraph2", v)} textarea rows={4} />
          </div>
          <div className="mt-8 max-w-xl">
            <ImageField label="Immagine Chi siamo" value={about.draft.image} onChange={(v) => setAbout("image", v)} logout={logout} ratio="aspect-[3/4]" />
          </div>
        </section>
      )}
    </div>
  );
}
